
import { cn } from "@/lib/utils";

const currentYear = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="bg-white border-t border-border/50 py-12">
      <div className="container-narrow">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <p className="text-muted-foreground max-w-md mb-6">
              No-code visual workflows for Bayesian data analysis — explore uncertainty, model outcomes, and uncover insights without writing a single line of code.
            </p>
          </div>

          <div>
            <h3 className="font-medium text-base mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {["Features", "Use Cases", "About", "Contact"].map((item, index) => (
                <li key={index}>
                  <a 
                    href={`#${item.toLowerCase().replace(" ", "-")}`} 
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-base mb-4">Legal</h3>
            <ul className="space-y-3">
              {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((item, index) => (
                <li key={index}>
                  <a 
                    href="#" 
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            © {currentYear} SwifQuery. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground mt-4 md:mt-0">
            Enabling data science and domain expertise to come together — simplifying Bayesian analysis for everyone.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
